if (!customElements.get('wlsn-buybox-with-options')) {
    class WLSNBuyboxWithOptions extends HTMLElement {
      constructor() {
        super();
  
        this.classes = {
          open: 'is-open',
          selected: 'is-selected',
          outOfView: 'is-out-of-view',
          swiper: 'js-wlsn-buybox-with-options-gallery',
          thumbs: 'js-wlsn-buybox-with-options-thumbs',
          list: 'swiper-wrapper',
          item: 'swiper-slide',
          option: 'wlsn-buybox-with-options__option',
          stickyOption: 'js-wlsn-buybox-with-options-sticky-bar-option',
          stickyOptionTitle: 'wlsn-buybox-with-options__sticky-option-title',
          stickyOptionsTrigger: 'js-wlsn-buybox-with-options-sticky-bar-options-trigger',
          stickyOptionsWrapper: 'js-wlsn-buybox-with-options-sticky-bar-options-wrapper',
          enableStickyCtaOptionsState: 'enable-sticky-cta-options-state',
          navigation: {
            prev: 'js-wlsn-buybox-with-options-gallery-prev',
            next: 'js-wlsn-buybox-with-options-gallery-next',
            progressbar: 'js-wlsn-buybox-with-options-gallery-pagination'
          }
        };
  
        this.elements = {
          slider: this.querySelector(`.${this.classes.swiper}`),
          thumbs: this.querySelector(`.${this.classes.thumbs}`),
          list: this.querySelector(`.${this.classes.list}`),
          items: this.querySelectorAll(`.${this.classes.item}`),
          options: this.querySelectorAll(`.${this.classes.option}`),
          stickyOptions: this.querySelectorAll(`.${this.classes.stickyOption}`),
          stickySelectedTitle: this.querySelector('.js-wlsn-buybox-with-options-sticky-bar-option-title'),
          prices: this.querySelectorAll('.js-wlsn-buybox-with-options-sticky-bar-price'),
          pricesCrossedOut: this.querySelectorAll('.js-wlsn-buybox-with-options-sticky-bar-price-crossed-out'),
          button: this.querySelector('.js-wlsn-buybox-with-options-sticky-bar-btn'),
          stickyOptionsTrigger: this.querySelector(`.${this.classes.stickyOptionsTrigger}`),
          stickyOptionsWrapper: this.querySelector(`.${this.classes.stickyOptionsWrapper}`),
          navigation: {
            prev: this.querySelector(`.${this.classes.navigation.prev}`),
            next: this.querySelector(`.${this.classes.navigation.next}`),
            progressbar: this.querySelector(`.${this.classes.navigation.progressbar}`)
          }
        };
  
        this.resizeHandler = this.handleResize.bind(this);
        this.observer = null;
        this.is_mobile = window.innerWidth <= 1199;
      }
  
      connectedCallback() {
        if (this.checkIfEmpty()) return;
  
        this.init();
        this.initOptions();
        window.addEventListener('resize', this.resizeHandler);
        this.initObserver();
        this.handleStickyOptionsTriggerClick();
      }
  
      disconnectedCallback() {
        if (this.swiper) this.swiper.destroy();
        window.removeEventListener('resize', this.resizeHandler);
        if (this.resizeTimeout) clearTimeout(this.resizeTimeout);
        if (this.observer) this.observer.disconnect();
      }
  
      checkIfEmpty() {
        const listInner = this.elements.list;
        if (!listInner || !listInner.children.length) {
          this.style.display = 'none';
          return true;
        }
        return false;
      }
  
      init() {
        if (!this.shouldInitialize()) return;
        this.initializeSwiper();
      }
  
      shouldInitialize() {
        return this.elements.items.length > 1;
      }
  
      handleResize() {
        if (this.resizeTimeout) clearTimeout(this.resizeTimeout);
  
        this.resizeTimeout = setTimeout(() => {
          const shouldInit = this.shouldInitialize();
  
          if (shouldInit && !this.swiper) {
            this.initializeSwiper();
          } else if (!shouldInit && this.swiper) {
            this.swiper.destroy(true, true);
            this.swiper = null;
          }
        }, 300);
      }
  
      initializeSwiper() {
        if (!this.elements.thumbs || !this.elements.slider) return;
  
        this.thumbs = new Swiper(this.elements.thumbs, {
          spaceBetween: 8,
          direction: 'horizontal',
          slidesPerView: 'auto',
          watchSlidesProgress: true
        });
  
        this.swiper = new Swiper(this.elements.slider, {
          slidesPerView: 1,
          spaceBetween: 10,
          watchSlidesProgress: true,
          navigation: {
            prevEl: this.elements.navigation?.prev,
            nextEl: this.elements.navigation?.next
          },
          pagination: {
            el: this.elements.navigation?.progressbar,
            type: 'progressbar'
          },
          thumbs: { swiper: this.thumbs }
        });
      }
  
    // Options logic
      initOptions() {
        this.addEventListener('click', (e) => {
          const mainOption = e.target.closest(`.${this.classes.option}`);
          const stickyOption = e.target.closest(`.${this.classes.stickyOption}`);
  
          if (mainOption) {
            this.selectOption(mainOption.dataset.optionIndex);
          }
  
          if (stickyOption) {
            this.selectOption(stickyOption.dataset.optionIndex);
          }
        });
  
        const firstOption = this.querySelector(`.${this.classes.option}`);
        if (firstOption) this.selectOption(firstOption.dataset.optionIndex);
      }
  
      selectOption(index) {
        if (!index) return;
  
        // Sync selected options
        this.elements.options.forEach(option => {
          option.classList.toggle(
            this.classes.selected,
            option.dataset.optionIndex === index
          );
        });
  
        this.elements.stickyOptions.forEach(option => {
          option.classList.toggle(
            this.classes.selected,
            option.dataset.optionIndex === index
          );
        });
  
        const mainOption = this.querySelector(
          `.${this.classes.option}[data-option-index="${index}"]`
        );
  
        const stickyOption = this.querySelector(
          `.${this.classes.stickyOption}[data-option-index="${index}"]`
        );
  
        const source = mainOption || stickyOption;
        if (!source) return;
  
        const price = source.dataset.customPrice;
        const crossedOutPrice = source.dataset.customCrossedoutPrice || '';
        const link = source.dataset.checkoutLinkRender;
  
        // Update button
        if (this.elements.button && link) {
          this.elements.button.setAttribute('href', link);
        }
  
        // Update price
        if (price && this.elements.prices) {
          this.elements.prices.forEach(el => el.innerHTML = price);
        }

        // Update crossed out price
        if (this.elements.pricesCrossedOut) {
          this.elements.pricesCrossedOut.forEach(el => {
            el.innerHTML = crossedOutPrice || '';
          });
        }
  
        // Update sticky bar title
        if (this.elements.stickySelectedTitle && stickyOption) {
          const titleEl = stickyOption.querySelector(`.${this.classes.stickyOptionTitle}`);
          this.elements.stickySelectedTitle.innerHTML = titleEl?.innerHTML || '';
        }
      }

    //   Sticky bar options dropdown

      handleStickyOptionsTriggerClick() {
        if (this.is_mobile) {
            if(this.elements.stickyOptionsTrigger && this.elements.stickyOptionsWrapper) {
              this.elements.stickyOptionsTrigger.addEventListener('click', () => {
                this.elements.stickyOptionsWrapper.classList.toggle(this.classes.open);
              });
            }
          }
      }
      
  
    //   Observer for sticky bar
      initObserver() {
        if (!this.classList.contains(this.classes.enableStickyCtaOptionsState)) {
          return;
        }
        this.observer = new IntersectionObserver(
          ([entry]) => {
            this.classList.toggle(
              this.classes.outOfView,
              !entry.isIntersecting
            );
          },
          {
            root: null,
            threshold: 0
          }
        );
  
        this.observer.observe(this);
      }
    }
  
    customElements.define('wlsn-buybox-with-options', WLSNBuyboxWithOptions);
  }